import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class CacService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private cacUrl = 'api/management';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBranchCACReport(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/getBranchCAC`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getBranchCACAmount(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/getBranchCACAmount`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    saveBranchCACAmount(rowData: any): Promise<any> {

        const url = `${this.cacUrl}/saveBranchCACAmount`;
        return this.http
        .post(url, $.param(rowData), { headers: this.headers })
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
    }

    deleteBranchAmount(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/deleteBranchAmount`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    getBranchCACPercentageReport(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/getBranchCACPercentage`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    getMeetingReportSources(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/getMeetingReportSources`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    calculateMeetingData(params: any): Promise<any> {

        const url = `${this.cacUrl}/calculateMeetingData`;
        return this.http
        .post(url, $.param(params), { headers: this.headers })
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
    }

    saveMeetingData(params: any): Promise<any> {

        const url = `${this.cacUrl}/saveMeetingData`;
        return this.http
        .post(url, $.param(params), { headers: this.headers })
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
    }

    getMeetingData(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cacUrl}/getMeetingData`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    branchMeetingExcel(params: any): Promise<any> {

        const url = `${this.cacUrl}/branchMeetingExcel`;
        return this.http
        .post(url, $.param(params), { headers: this.headers })
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/cac.service.ts